import { fetcher } from "helpers/fetcher";

import { TGetDetailJobListingReq, TGetDetailJobListingRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getDetailJobListing = async (params?: TGetDetailJobListingReq) => {
  return await fetcher<TGetDetailJobListingRes, TGetDetailJobListingReq>(
    ENDPOINT.CORPORATION.GET_DETAIL_JOB_LISTING,
    {
      params: params?.data,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.GET_DETAIL_JOB_LISTING.version,
        [API_HEADER.CORP_ID]: params?.idCorp,
        [API_HEADER.BLOCK_404]: true,
      },
    }
  );
};

export const queryGetDetailJobListing = async (
  params?: TGetDetailJobListingReq
) => {
  return (await getDetailJobListing(params)).data;
};

queryGetDetailJobListing._key = (params?: TGetDetailJobListingReq) => [
  ENDPOINT.CORPORATION.GET_DETAIL_JOB_LISTING.url,
  params,
];
